import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Square from "../pages/square/page";
import ArticleDetail from "../pages/article/page";
import Submit from "../pages/submit/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "square", element: <Square /> },
      { path: "article/:id", element: <ArticleDetail /> },
      { path: "submit", element: <Submit /> },
      { path: "faq", element: <Faq /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;